module.exports = __webpack_public_path__ + "img/194.28958aba.jpg";